import { render, staticRenderFns } from "./TaskHeader.vue?vue&type=template&id=51c9fc4e&scoped=true"
import script from "./TaskHeader.vue?vue&type=script&lang=js"
export * from "./TaskHeader.vue?vue&type=script&lang=js"
import style0 from "./TaskHeader.vue?vue&type=style&index=0&id=51c9fc4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c9fc4e",
  null
  
)

export default component.exports